<template>
  <div class="form-row align-items-end">

    <div class="col-12" v-if="schoolStatus && !onlyAcademic">
      <form-select :label="Lang.get('messages.all_schools')" :options="SchoolsForSelect" name="school"
        :model="localFilters" label-field="name" value-field="id" :reduce="(value) => value.id"
        @change="loadAllDataToSelects()" :multiple="isSuperadminLoggedSchool" :selectAllOption="false" />
    </div>
    <!--      && !onlyAcademic-->
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="academicYearStatus">
      <form-select :label="Lang.get('messages.academic_year')" :options="academicYears" name="academicYear"
        :model="localFilters" :errors="formErrors" label-field="name" @change="changeMarkingPeriod" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="showAnotherAcademicYear">
      <form-select :label="Lang.get('messages.another_academic_year')" :reduce="(value) => value.id"
        :options="academicYears" name="doesnotHaveAcademicYearEnrollment" :model="localFilters" :errors="formErrors"
        label-field="name" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="stageStatus && !onlyAcademic">
      <form-select :label="Lang.get('messages.stage')" :options="stagesForSelect" name="stageEnrollment"
        :model="localFilters" :errors="formErrors" label-field="name_with_school" value-field="id"
        :reduce="(value) => value.id" @change="getYearLevels()" :selectAllOption="false" multiple />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="yearLevelStatus && !onlyAcademic">
      <form-select :label="Lang.get('messages.yearLevel')" :options="yearLevelForSelect" name="yearLevelEnrollment"
        :model="localFilters" :errors="formErrors" label-field="name" value-field="id" :reduce="(value) => value.id"
        @change="getClasses();" :selectAllOption="false" multiple />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic">
      <form-select :label="Lang.get('messages.classes')" :options="classes" name="classEnrollment" :model="localFilters"
        :errors="formErrors" label-field="name" value-field="id" :reduce="(value) => value.id" :selectAllOption="false"
        multiple />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && showBox">
      <form-select :label="Lang.get('messages.name_box')" :options="usersForSelect" name="user" :model="localFilters"
        label-field="name" :reduce="(value) => value.id" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && showfeeCategory">
      <form-select :label="Lang.get('messages.feeCategory')" :options="InvoiceCategoryForSelect" name="category"
        :model="localFilters" :errors="formErrors" label-field="name_with_school" @change="getFeeTypes"
        :selectAllOption="false" multiple :reduce="(value) => value.id" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && parent_code">
      <form-input :label="Lang.get('messages.parent_code_name')" name="parentNameOrCode" :model="localFilters" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && student_code">
      <form-input :label="Lang.get('messages.student_code_name')" name="nameOrCode" :model="localFilters" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="marking_period && !onlyAcademic">
      <form-select :label="Lang.get('messages.marking_period')" :options="markingPeriodsForSelect"
        name="marking_period_id" :model="localFilters" :errors="formErrors" label-field="name_with_school"
        :reduce="(value) => value.id" @change="markingPeriodChange" :multiple="true" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="from_date && !onlyAcademic">
      <form-date :label="Lang.get('messages.from_date')" name="billingFromDate" :options="dateOptions"
        :model="localFilters" :errors="formErrors" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="to_date && !onlyAcademic">
      <form-date :label="Lang.get('messages.to_date')" name="billingToDate" :options="dateOptions" :model="localFilters"
        :errors="formErrors" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="from && !onlyAcademic">
      <form-input :label="Lang.get('messages.' + balance_from)" name="from" :model="localFilters" type="number" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="to && !onlyAcademic">
      <form-input :label="Lang.get('messages.' + balance_to)" name="to" :model="localFilters" type="number" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="from && !onlyAcademic">
      <form-input :label="Lang.get('messages.paid amount') + ' - ' + Lang.get('messages.from')" name="paidFrom"
        :model="localFilters" type="number" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="to && !onlyAcademic">
      <form-input :label="Lang.get('messages.paid amount') + ' - ' + Lang.get('messages.to')" name="paidTo"
        :model="localFilters" type="number" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="fromNumber && !onlyAcademic">
      <form-input :label="Lang.get('messages.from_number')" name="fromNumber" type="number" :model="localFilters" />

    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="toNumber && !onlyAcademic">
      <form-input :label="Lang.get('messages.to_number')" name="toNumber" type="number" :model="localFilters" />
    </div>
    <!--      <div class="col-sm-12 col-md-6 col-lg-4" v-if="$mods.students.form_inputs.unspecified_nationality && !onlyAcademic">-->
    <!--        <form-switch :label="Lang.get('messages.unspecified_nationality')"-->
    <!--                     name="unspecifiedNationality" :model="localFilters" :errors="formErrors"-->
    <!--                     @change="((value)=>unspecifiedNationalityStatusChange(value))" />-->
    <!--      </div>-->

    <!--      <div class="col-sm-12 col-md-6 col-lg-4" v-if="$mods.students.form_inputs.unspecified_nationality && !onlyAcademic">-->
    <!--        <form-select :label="Lang.get('messages.unspecified_nationality')" :options="UnspecifiedNationalitiesForSelect"-->
    <!--                     name="unspecifiedNationality" :model="localFilters"-->
    <!--                     label-field="name" :reduce="(value)=>value.id" @change="((value)=>{unspecifiedNationalityStatusChange(value);clearInput('unspecified_nationality')})"/>-->
    <!--      </div>-->
    <!--      <div class="col-sm-12 col-md-6 col-lg-4" v-if="$mods.school.ahlia">-->
    <!--        <form-input :label="Lang.get('messages.nationality')" name="nationalityText"  :model="localFilters" />-->
    <!--      </div>-->
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && nationality && !knet">
      <form-select :label="Lang.get('messages.nationality')" :options="nationalitiesForSelect" name="nationalityKeyword"
        :model="localFilters" label-field="name_with_school" :reduce="(value) => value.name_en"
        @change="clearInput('nationalityKeyword')" :disabled="unspecifiedNationalityStatus" :selectAllOption="false"
        multiple />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && studentStatus && !knet">
      <form-select :label="Lang.get('messages.student_status')" :options="studentStatusForSelect" name="studentStatus"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="registerStatus && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.registration_status')" :options="registrationStatusForSelect"
        name="registrationType" :model="localFilters" :errors="formErrors" label-field="name"
        :reduce="(val) => val.id" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="studyStatus && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.study_status')" :options="studyStatusForSelect" name="studyStatus"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(val) => val.id" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && medicalAvailability && !knet">
      <form-select :label="Lang.get('messages.medical_availability')" :options="booleanForSelect"
        name="medicalAvailability" :model="localFilters" :errors="formErrors" label-field="name"
        :reduce="(value) => value.id" @change="clearInput('medicalAvailability')" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && religion && !knet">
      <form-select :label="Lang.get('messages.religion')" :options="religionsForSelect" name="religion"
        :model="localFilters" label-field="name_with_school" :reduce="(value) => value.id"
        @change="clearInput('religion')" />
    </div>
<!--    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && studentType && !knet">-->
<!--      <form-select :label="Lang.get('messages.student_type')" :options="studentTypesForSelect" name="studentType"-->
<!--        :model="localFilters" label-field="name" :reduce="(value) => value.id" @change="clearInput('student_type')" />-->
<!--    </div>-->
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && gender && !knet">
      <form-select :label="Lang.get('messages.gender')" :options="genderForSelect" name="gender" :model="localFilters"
        label-field="name" :reduce="(value) => value.id" @change="clearInput('gender')" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && isStaff && !knet">
      <form-select :label="Lang.get('messages.working_sons')" :options="booleanForSelect" name="isStaff"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="!onlyAcademic && atExpenseOf && !knet">
      <form-select :label="Lang.get('messages.expenses_of') + ' (' + Lang.get('messages.financial') + ')'"
        :reduce="(value) => value.id" :options="expensesTypesforSelect" name="atExpenseOf" :model="localFilters"
        :errors="formErrors" label-field="name" />
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4" v-if="discount_type && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.discountType')" :options="discountTypesForSelect"
        :reduce="(value) => value.id" name="modelDiscountType" :model="localFilters" :errors="formErrors"
        label-field="name" @change="getCategoryTypes()" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="discount && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.discount')" :options="discountTypeForSelect" name="modelDiscount"
        :model="localFilters" :errors="formErrors" label-field="name_with_school" :reduce="(value) => value.id" />
    </div>

    <div v-if="payment && !onlyAcademic && !knet" class="col-sm-12 col-md-6 col-lg-4">
      <form-select :label="Lang.get('messages.payment_type')" :options="paymentTypesForSelect" name="paymentType"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4"
      v-if="organization && $mods.billing.funding_organization && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.organization')" :reduce="(value) => value.id"
        :options="organizationsForSelect" name="organization" :model="localFilters" :errors="formErrors"
        label-field="name" multiple />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="registration_type && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.registrationType')" :options="registrationStatusForSelect"
        name="registrationType" :model="localFilters" :errors="formErrors" label-field="name"
        :reduce="(value) => value.id" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="registration_type && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.external_school')" :options="prevSchoolsForSelect" name="previousSchool"
        :model="localFilters" :reduce="(value) => value.id" :errors="formErrors" label-field="name_with_school" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="sanad_type && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.sand_type')" :options="sandTypesForSelect" name="action"
        :model="localFilters" label-field="name" :reduce="(value) => value.id" :selectAllOption="false" multiple />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="expenseAt && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.expense_at') + ' (' + Lang.get('messages.registration') + ')'"
        :options="expenseTypesForSelect" name="expenseAt" :model="localFilters" :errors="formErrors" label-field="name"
        :reduce="(value) => value.id" />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="paymentMethod && !onlyAcademic && !knet">
      <form-select :label="Lang.get('messages.method')" :options="paymentMethodsForSelect" name="paymentMethod"
        :model="localFilters" :errors="formErrors" label-field="name" @change="clearInput('paymentMethod')"
        :reduce="(value) => value.id" :selectAllOption="false" multiple />
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4" v-if="clientTypeFilter && !knet">
      <form-select :label="Lang.get('messages.type')" :options="clientTypesOptions" name="clientType"
        :model="localFilters" :errors="formErrors" label-field="name" @change="clearInput('clientTypes')"
        :reduce="(value) => value.id" />
    </div>

  </div>
</template>

<script>
import { mapState , mapGetters } from "vuex";
import AcademicYear from "@api/academic_year.api";
import Invoice from "@api/invoice.api";
import YearLevel from "@api/year_level.api";
import School from "@api/school.api";
import Stage from "@api/stage.api";
import Classes from "@api/class.api";
import Students from "@api/student.api";
import Nationality from "@api/nationality.api";
import Organization from "@api/organizations.api";
import District from "@api/district.api";
import Area from "@api/area.api";
import WorkSector from "@api/work_sector.api";
import Religion from "@api/religion.api";
import InvoiceCategory from "@api/invoice_category.api";
import FeeType from "@api/fee_type_details.api";
import MarkingPeriod from "@api/marking_period.api";
import Student from "@api/student.api";
import Lang from "../../lang";
import StaffDiscount from "@api/staff_discount.api";
import OtherDiscounts from "@api/other_discount.api";
import RegistrationDiscounts from "@api/registration_discount.api";
import SiblingDiscount from "@api/sibling_discount.api";
import WithdrawalDiscounts from "@api/withdrawal_discount.api";
import PrevSchool from "@api/previous_school.api";

export default {
  name: "BillingFilter",
  computed: {
    ...mapState("users", ["user"]),
    ...mapGetters(["isSuperadminLoggedSchool"]),
    school() {
      return this.user.school;
    },
    clientTypesOptions() {
      return [
        {
          id: 1,
          name: this.Lang.get('messages.parent'),
        },
        {
          id: 4,
          name: this.Lang.get('messages.customer'),
        }
      ];
    },
  },
  props: {
    filters: {
      type: [Object, Array],
      required: true
    },
    from_date: {
      type: [Boolean],
      default: true,
    },
    to_date: {
      type: [Boolean],
      default: true,
    },
    from: {
      type: [Boolean],
      default: true,
    },
    to: {
      type: [Boolean],
      default: true,
    },
    marking_period: {
      type: [Boolean],
      default: false,
    },
    discount_type: {
      type: [Boolean],
      default: true,
    },
    discount: {
      type: [Boolean],
      default: true,
    },
    payment: {
      type: [Boolean],
      default: false,
    },
    sand_type: {
      type: [Boolean],
      default: false,
    },
    organization: {
      type: [Boolean],
      default: false,
    },
    registration_type: {
      type: [Boolean],
      default: false,
    },
    studyStatus: {
      type: [Boolean],
      default: true,
    },
    fromNumber: {
      type: [Boolean],
      default: false,
    },
    toNumber: {
      type: [Boolean],
      default: false,
    },
    registerStatus: {
      type: [Boolean],
      default: true,
    },
    sanad_type: {
      type: [Boolean],
      default: false,
    },
    balance_to: {
      type: [String],
      default: 'student_money_to',
    },
    balance_from: {
      type: [String],
      default: 'student_money_from',
    },
    multiple_schools: {
      type: [Boolean],
      default: true,
    },
    expenseAt: {
      type: [Boolean],
      default: true,
    },
    paymentMethod: {
      type: [Boolean],
      default: false,
    },
    schoolStatus: {
      type: [Boolean],
      default: true,
    },
    academicYearStatus: {
      type: [Boolean],
      default: true,
    },
    yearLevelStatus: {
      type: [Boolean],
      default: true,
    },
    stageStatus: {
      type: [Boolean],
      default: true,
    },
    onlyAcademic: {
      type: [Boolean],
      default: false,
    },
    clientTypeFilter: {
      type: [Boolean],
      default: false,
    },
    student_code: {
      type: [Boolean],
      default: true,
    },
    nationality: {
      type: [Boolean],
      default: true,
    },
    studentStatus: {
      type: [Boolean],
      default: true,
    },
    medicalAvailability: {
      type: [Boolean],
      default: true,
    },
    religion: {
      type: [Boolean],
      default: true,
    },
    gender: {
      type: [Boolean],
      default: true,
    },
    showAnotherAcademicYear: {
      type: [Boolean],
      default: false
    },
    showBox: {
      type: [Boolean],
      default: true
    },
    showfeeCategory: {
      type: [Boolean],
      default: true
    },
    knet: {
      type: [Boolean],
      default: false
    },
    studentType: {
      type: [Boolean],
      default: true
    },
    isStaff: {
      type: [Boolean],
      default: true
    },
    atExpenseOf: {
      type: [Boolean],
      default: true
    },
    parent_code: {
      type: [Boolean],
      default: true
    },

  },
  watch: {
    localFilters: {
      deep: true,
      handler() {
        this.$emit('filtersUpdated', this.localFilters, this.markingPeriodsForSelect);
      }
    }
  },
  async created() {
    this.localFilters = _.cloneDeep({
      school: [],
      enrollment: 1,
      withoutGlobalScope: "existStudent",
      academicYear: [],
      stageEnrollment: [],
      yearLevelEnrollment: [],
      classEnrollment: [],
      religion: [],
      enrolledAcademicYear: [],
      gender: [],
      nationalityKeyword: [],
      studentType: [],
      registrationType: [],
      districtId: [],
      areaId: [],
      medicalFileAvailability: [],
      isParentStaff: [],
      studentStatus: [],
      expenseAt: [],
      schoolType: [],
      previousSchool: [],
      code: '',
      civilId: '',
      fatherCivilId: '',
      fatherWorkSectorKeyword: '',
      motherWorkSectorKeyword: '',
      fromJoinedDate: '',
      toJoinedDate: '',
      fromDate: '',
      toDate: '',
      from: '',
      to: '',
      category: [],
      user: [],
      marking_period_id: [],
      medicalAvailability: [],
      isStaff: [],
      atExpenseOf: [],
      modelDiscountType: [],
      modelDiscount: [],
      paymentType: [],
      organization: [],
      action: [],
      paymentMethod: [],
      clientType: [],
      parentNameOrCode: '',
      nameOrCode: '',
      billingFromDate: '',
      billingToDate: '',
      paidFrom: '',
      paidTo: '',
      fromNumber: '',
      toNumber: '',
    });
    await this.sanadTypes();
    await this.getAcademicYears();
    await this.getRegistrationStatus();
    await this.getStudyStatus();


    this.UnspecifiedNationalitiesForSelect = [
      { id: 0, name: Lang.get('messages.yes_unspecified_nationality') },
      { id: 1, name: Lang.get('messages.no_unspecified_nationality') },
    ]

    if (this.school && !this.isSuperadminLoggedSchool) {
      this.$set(this.localFilters, 'school', this.school.id);
      this.SchoolsForSelect = [this.school];
    }
    else {
      await School.list({ page: 0 }).then(({ data: { data } }) => {
        this.SchoolsForSelect = data.filter((school) => school.id != -1)
        this.$set(this.localFilters, 'school', data.filter((school) => school.id != -1).map((school) => school.id));
      });
    }

    // if (this.$mods.school.ahlia) {
    //   if (this.multiple_schools) {
    //     this.$set(
    //       this.localFilters,
    //       'school',
    //       this.SchoolsForSelect.filter((school) => school.id != -1).map((school) => school.id)
    //     );
    //   } else {
    //     // Set the specific school ID if not multiple
    //     _.set(this.localFilters, 'school', this.school.id);
    //   }
    // }

    await this.loadAllDataToSelects();
    await this.getBooleanOptions();
    await this.getExpensesTypes();
    await this.getDiscountTypes();
    await this.getOrganizations();
    await this.getExpenseTypes();

  },
  data() {
    return {
      academicYears: [],
      yearLevelForSelect: [],
      SchoolsForSelect: [],
      stagesForSelect: [],
      usersForSelect: [],
      classes: [],
      users: [],
      studentStatusForSelect: [],
      religionsForSelect: [],
      nationalitiesForSelect: [],
      UnspecifiedNationalitiesForSelect: [],
      genderForSelect: [],
      studentTypesForSelect: [],
      workSectorsForSelect: [],
      sandTypesForSelect: [],
      paymentTypesForSelect: [],
      paymentMethodsForSelect: [],
      InvoiceCategoryForSelect: [],
      markingPeriodsForSelect: [],
      expensesTypesforSelect: [],
      discountTypeForSelect: [],
      booleanForSelect: [],
      discountTypesForSelect: [],
      organizationsForSelect: [],
      prevSchoolsForSelect: [],
      expenseTypesForSelect: [],
      registrationStatusForSelect: [],
      districts: [],
      areas: [],
      names: [],
      unspecifiedNationalityStatus: false,
      dateOptions: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "j F, Y",
      },
      localFilters: {
        page: 1,
        discountType: [],
        modelDiscountType: [],
        modelDiscount: [],
        school: [],
        from: '',
        to: '',
        withoutGlobalScope: 'existStudent',
        enrollment: 1,
        stageEnrollment: [],
        classEnrollment: [],
        yearLevelEnrollment: [],
        user: [],
        marking_period_id: [],
        billingFromDate: '',
        billingToDate: '',

      },
      studyStatusForSelect: [],
    }
  },
  methods: {
    loadAllDataToSelects: _.debounce(async function () {
      if (this.academicYearStatus) {
        await this.getPrevSchools();
      }
      if (this.organization && this.$mods.billing.funding_organization && !this.onlyAcademic && !this.knet) {
        await this.getOrganizations();
      }
      console.log("this.stageStatus && !this.onlyAcademic"  , this.stageStatus && !this.onlyAcademic)
      if (this.stageStatus && !this.onlyAcademic) {
        await this.getStages();
      }
      if (!this.onlyAcademic && this.nationality && !this.knet) {
        await this.getNationalities();
      }
      if (!this.onlyAcademic && this.gender && !this.knet) {

        await this.getGenderTypes();
      }

      if (!this.onlyAcademic && !this.knet) {

        await this.getStudentTypes();
      }
      // await this.getDistrict();
      // await this.getWorkSectors();
      if (!this.onlyAcademic && this.getStudentStatus && !this.knet) {
        await this.getStudentStatus();
      }

      if (!this.onlyAcademic && this.religion && !this.knet) {
        await this.getReligions();
      }
      if (!this.onlyAcademic && this.payment && !this.knet) {
        await this.paymentTypes();
      }
      if (!this.onlyAcademic && this.paymentMethod && !this.knet) {
        await this.paymentMethods();
      }
      if (!this.onlyAcademic && this.showfeeCategory) {
        await this.getInvoiceCategories();
      }
      if (!this.onlyAcademic && this.showBox) {
        await this.getDailyCreditUsers();
      }
      if (!this.onlyAcademic && this.marking_period) {
        await this.getMarkingPeriods();
      }
      if (this.discount && !this.onlyAcademic && !this.knet) {

        await this.getCategoryTypes();
      }
    }, 300),

    async getCategoryTypes() {
      if (!this.localFilters.modelDiscountType) {

        _.set(this.localFilters, 'modelDiscount', []);
        this.discountTypeForSelect = _.cloneDeep([]);
        return false;
      }
      if (_.isEmpty(this.localFilters.academicYear) || _.isEmpty(this.localFilters.modelDiscountType)) {
        return false;
      }

      let filter = {
        page: 0,
        academicYear: _.get(this.localFilters, 'academicYear.id') || this.localFilters.academicYear,
        school: this.localFilters.school
      };

      if (this.localFilters.modelDiscountType == 'App\\Models\\StaffDiscount') {// staff discount
        await StaffDiscount.list(filter).then(res => {
          this.discountTypeForSelect = res.data.data;
        });
      }

      else if (this.localFilters.modelDiscountType == 'App\\Models\\SiblingDiscount') {// sibling discount
        await SiblingDiscount.list(filter).then(res => {
          this.discountTypeForSelect = res.data.data;
        });
      }

      else if (this.localFilters.modelDiscountType == 'App\\Models\\RegistrationDiscount') {// join late discount
        await RegistrationDiscounts.list(filter).then(res => {
          this.discountTypeForSelect = res.data.data;
        });
      }

      else if (this.localFilters.modelDiscountType == 'App\\Models\\WithdrawalDiscount') {// withdrawal discount
        await WithdrawalDiscounts.list(filter).then(res => {
          this.discountTypeForSelect = res.data.data;
        });
      }

      else if (this.localFilters.modelDiscountType == 'App\\Models\\OtherDiscount') {// other discount
        await OtherDiscounts.list(filter).then(res => {
          this.discountTypeForSelect = res.data.data;
        });
      }
    },
    async getDiscountTypes() {
      return (this.discountTypesForSelect = [
        { id: 'App\\Models\\RegistrationDiscount', name: Lang.get('messages.sidebar.registration-discounts') },
        { id: 'App\\Models\\StaffDiscount', name: Lang.get('messages.sidebar.staff-discounts') },
        { id: 'App\\Models\\WithdrawalDiscount', name: Lang.get('messages.sidebar.withdrawal-discounts') },
        { id: 'App\\Models\\SiblingDiscount', name: Lang.get('messages.sidebar.sibling-discounts') },
        { id: 'App\\Models\\OtherDiscount', name: Lang.get('messages.sidebar.other-discounts') }]);
    },
    async getExpensesTypes() {
      await Student.getExpensesTypes().then(res => {
        this.expensesTypesforSelect = res.data.data
      });
    },
    async sanadTypes() {
      if (this.$route.path == '/invoices/report/monthly') {
        return (this.sandTypesForSelect = [
          { 'id': 3, 'name': this.Lang.get('messages.paid_organization') },
          { 'id': 4, 'name': this.Lang.get('messages.paid_parent') },
        ]);
      } else {
        return (this.sandTypesForSelect = [
          { 'id': 3, 'name': this.Lang.get('messages.paid_organization') },
          { 'id': 4, 'name': this.Lang.get('messages.paid_parent') },
          { 'id': 5, 'name': this.Lang.get('messages.parents_refund') },]);
      }

    },
    async paymentTypes() {
      await Invoice.getPaymentTypes().then(res => {
        this.paymentTypesForSelect = res.data
      });
    },
    async getInvoiceCategories() {
      let checkInvoiceCategoryType = this.$route.name == 'ecommerce-daily-collection-report' ? 1 : 0;
      await InvoiceCategory.list({
        page: 0,
        school: this.localFilters.school,
        isEcommerceCategory: checkInvoiceCategoryType
      }).then(res => (this.InvoiceCategoryForSelect = res.data.data));

    },
    async paymentMethods() {
      // let checkInvoiceCategoryType = this.$route.name == 'ecommerce-daily-collection-report' ? 1 : 0;
      if (this.$route.name == 'ecommerce-daily-collection-report') {
        this.paymentMethodsForSelect = [
          { id: 1, name: this.Lang.get('messages.cache') },
          { id: 2, name: this.Lang.get('messages.electronic_payment') }
        ];
      } else {
        await Invoice.getPaymentMethods().then(res => {
          this.paymentMethodsForSelect = res.data
        });
      }
    },
    unspecifiedNationalityStatusChange(val) {
      this.unspecifiedNationalityStatus = val;
      // this.unspecifiedNationalityStatus = val.status;
    },
    async getBooleanOptions() {
      return (this.booleanForSelect = [
        { id: 1, name: this.Lang.get("messages.yes") },
        { id: 0, name: this.Lang.get("messages.no") },
      ]
      );
    },
    async getReligions() {
      await Religion.list({
        page: 1,
        school: this.localFilters.school
      }).then(res => {
        this.religionsForSelect = res.data.data
      })
    },
    async getStudentStatus() {
      await Students.getStatusTypes({
        customStatus: true
      }).then(res => {
        this.studentStatusForSelect = res.data.types
      })
    },
    async getWorkSectors() {
      await WorkSector.list({
        page: 0,
        school: this.localFilters.school
      }).then(res => {
        this.workSectorsForSelect = res.data.data
      })
    },
    async getDistrict() {
      await District.list({
        page: 0,
        school: this.localFilters.school
      }).then(({ data: { data } }) => (this.districts = data));
    },
    async getArea() {
      await Area.list({ page: 0, district: this.localFilters.district }).then(({ data: { data } }) => (this.areas = data));
    },
    async getStudentTypes() {
      await Organization.getStudentTypes().then(res => {
        this.studentTypesForSelect = res.data.data
      })
    },
    async getGenderTypes() {
      await Students.getGenderTypes().then((res) => {
        this.genderForSelect = res.data.data;
      });
    },
    async getNationalities() {
      await Nationality.list({
        page: 0,
        school: this.localFilters.school
      }).then(res => {
        this.nationalitiesForSelect = res.data.data
      })
    },

    async getStages() {


      this.stagesForSelect = [];


      // If school is null/undefined or empty array, return early

      if (!this.localFilters.school && !_.size(this.localFilters.school)) {
        console.warn("No school selected or school is empty.", this.localFilters.school);
        this.stagesForSelect = [];
        return false;
      }


      // Ensure school is an array, even if it comes as a single value
      const schoolFilter = Array.isArray(this.localFilters.school)
        ? this.localFilters.school
        : [this.localFilters.school];



      console.log(schoolFilter);
      await Stage.list({
        page: 0,
        school: schoolFilter,
        hasSchool: true,

      }).then(res => {
        this.stagesForSelect = res.data.data
      });

    },

    async getYearLevels() {
      this.yearLevelForSelect = [];
      if (!_.size(this.localFilters.stageEnrollment)) {
        this.yearLevelForSelect = [];
        return false;
      }
      await YearLevel.list({
        page: 0,
        school: this.localFilters.school,
        stage: this.localFilters.stageEnrollment
      }).then(res => (this.yearLevelForSelect = res.data.data));
    },
    async getClasses() {
      this.classes = [];
      if (!_.size(this.localFilters.yearLevelEnrollment) || (this.$mods.school_settings.classes.form_inputs.multi_academic_years && !_.get(this.localFilters, 'academicYear.id'))) {
        this.classes = [];
        return false;
      }

      await Classes.list({
        page: 0,
        yearLevel: _.get(this.localFilters, 'yearLevelEnrollment'),
        school: this.localFilters.school,
        academicYears: this.$mods.school_settings.classes.form_inputs.multi_academic_years ? _.get(this.localFilters, 'academicYear.id') : ''
      }).then((res) => (this.classes = res.data.data));

    },
    async getDailyCreditUsers() {
      await Invoice.getDailyCreditUsers({
        school: this.localFilters.school
      }).
        then(response => {
          this.usersForSelect = response.data.users.length ? response.data.users : [];

        });
    },
    async getAcademicYears() {
      await AcademicYear.list({
        page: 0
      }).then(
        ({ data: { data } }) => {
          (this.academicYears = data)
          this.$set(this.localFilters, 'academicYear', data.filter(year => year.active)[0] || 0);
          this.$set(this.localFilters, 'academicYearEnrollment', data.filter(year => year.active)[0] || 0);//for enrollment
          this.getMarkingPeriods();
        });
    },
    async getFeeTypes() {
      if (_.isEmpty(this.localFilters.academicYear) || _.isEmpty(this.localFilters.invoiceCategory)) {
        return false;
      }
      let filter = {
        page: 0,
        academicYear: this.localFilters.academicYear.id,
        category: this.localFilters.invoiceCategory.id,
        school: this.localFilters.school
      }
      await FeeType.list(filter).then(
        ({ data: { data } }) => {
          (this.feeTypesForSelect = data)
        });
    },
    updateSelectedNames() {
      if (this.localFilters.hasOwnProperty('school')) {
        this.names["selectedSchoolName"] = this.SchoolsForSelect.find(item => item.id === this.localFilters.school).name;
      }
      if (this.localFilters.hasOwnProperty('yearLevelEnrollment')) {
        this.names["selectedYearLevelName"] = this.yearLevelForSelect.find(item => item.id === this.localFilters.yearLevelEnrollment).name;
      }
      if (this.localFilters.hasOwnProperty('classEnrollment')) {
        this.names["selectedClassName"] = _.get(this.classes.find(item => item.id === this.localFilters.classEnrollment), 'name');
      }
      this.$emit('updateNames', this.names);
    },
    async getMarkingPeriods() {

      await MarkingPeriod.list({
        page: 0,
        school: this.localFilters.school,
        academicYear: _.get(this.localFilters, 'academicYear.id') || this.localFilters.academicYear,
      }).then((res) => {
        this.markingPeriodsForSelect = res.data.data;
        this.$emit('localFiltersUpdated', this.localFilters, this.markingPeriodsForSelect);
      });

    },

    changeMarkingPeriod() {
      this.getMarkingPeriods();
      this.getCategoryTypes();
      this.getClasses();
      this.$set(this.localFilters, 'academicYearEnrollment', _.get(this.localFilters, 'academicYear.id'));
    },

    markingPeriodChange() {
      this.$emit('localFiltersUpdated', this.localFilters, this.markingPeriodsForSelect);
    },
    async getPrevSchools() {
      this.prevSchoolsForSelect = _.cloneDeep([]);
      if (!_.isEmpty(this.localFilters.school)) {
        await PrevSchool.list({
          page: 0,
          school: this.localFilters.school.map((sch) => sch),
        }).then((res) => {
          this.prevSchoolsForSelect = res.data.data;
        });
      }

    },
    async getOrganizations() {
      await Organization.list({
        page: 0,
        school: _.get(this.localFilters, 'school')
      }).then((res) => {
        this.organizationsForSelect = res.data.data;
      });
    },
    async getExpenseTypes() {
      await Student.getExpenseTypes()
        .then(response => {
          this.expenseTypesForSelect = response.data.data.length ? response.data.data : [];
        });
    },

    async getRegistrationStatus() {
      await Students.getRegistrationStatus().then(res => {
        this.registrationStatusForSelect = res.data.types
      });
    },

    async getStudyStatus() {
      await Students.getStudyStatus().then(res => {
        this.studyStatusForSelect = res.data.types
      });
    },

  }
}
</script>

<style scoped></style>